__turbopack_context__.v({
  "notStartedContainer": "_2uDlMa_notStartedContainer",
  "notStartedText": "_2uDlMa_notStartedText",
  "playBtnWrapper": "_2uDlMa_playBtnWrapper",
});
